// extracted by mini-css-extract-plugin
export default {"Box":"table-header-module__Box--DwC1T","Box_1":"table-header-module__Box_1--F0zZK"};